import { css } from '@emotion/css';

export const messageInputMaxHeight = css`
  max-height: 30%;
`;

export const inputPreviewCardStyles = css`
  width: 28rem;
  @media (max-width: 768px) {
    width: 20rem;
  }
`;

export const inputMentionsContainer = css`
  grid-template-columns: repeat(auto-fill, 28rem);
`;

export const inputStyles = css`
  min-height: 4.8rem;

  .ProseMirror {
    position: relative;
    color: var(--text-paragraph);
    width: auto !important;

    & > * {
      padding-inline-start: 0 !important;
      word-break: break-word;
    }

    .placeholder::before {
      height: auto !important;
      position: absolute;
      max-width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    span.emoji {
      font-size: 1.6rem;
      vertical-align: bottom;
    }
  }
`;

export const mediaContainerStyles = css`
  max-width: 28rem;

  &.LIST {
    width: calc(100% - 1rem);
  }
`;

export const iconButtonStyles = css`
  width: 3.2rem;
  height: 3.2rem;
  padding: 0;
`;

const editButtonStyles = css`
  height: 3.2rem;
  min-width: unset;
  border-radius: 0.6rem !important;
`;

const EDIT_BUTTON_CLASSES = {
  label: 'label-02',
};

export const EDIT_BUTTON_PROPS = {
  className: editButtonStyles,
  classes: EDIT_BUTTON_CLASSES,
  shape: 'square' as const,
  size: 'small' as const,
};

export const REACTION_SELECTOR_OVERRIDES = { MenuButton: { classes: { root: '' } } };

export const padding156 = css`
  padding-inline-end: 15.6rem;
`;

//hack image node at end is creating unwanted behaviour for mention node: https://github.com/ProseMirror/prosemirror-view/blob/128620ca6e68153f3e51ca13ceab358495767a0b/src/viewdesc.js#L1259
export const hideImageSeparator = css`
  .ProseMirror-separator {
    display: inline;
    width: 0px !important;
  }
`;
